import React, { useEffect, useMemo, useState } from "react";

import Stack from "veneer/Stack";
import { Colors } from "veneer/Theme";
import Typography from "veneer/Typography";

import WidgetContainer from "../WidgetContainer";

export default function CurrentTimeWidget() {
  const [now, setNow] = useState(() => new Date());
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    const interval = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(interval);
  }, []);

  const formattedTime = useMemo(() => {
    try {
      return new Intl.DateTimeFormat(undefined, {
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        month: "short",
        second: "2-digit",
        timeZone: timezone,
        year: "numeric",
      }).format(now);
    } catch {
      return now.toLocaleString();
    }
  }, [now, timezone]);

  return (
    <WidgetContainer>
      <Stack alignItems="center" flex={1} justifyContent="center" p={2}>
        <Typography variant="h3">{formattedTime}</Typography>
        <Typography color={Colors.gray700} variant="caption">
          {timezone}
        </Typography>
      </Stack>
    </WidgetContainer>
  );
}
